export default "__VITE_ASSET__BXbmbjRw__"